import { useTranslation } from "@/i18n/LanguageContext";
import { useNavigate } from "react-router-dom";

const LanguageToggle = ({ className = "" }: { className?: string }) => {
  const { lang, setLang } = useTranslation();
  const navigate = useNavigate();

  const switchTo = (newLang: "en" | "bg") => {
    setLang(newLang);
    navigate(newLang === "bg" ? "/bg" : "/");
  };

  return (
    <div className={`flex items-center gap-1 text-xs ${className}`}>
      <button
        onClick={() => switchTo("en")}
        className={`transition-colors duration-300 ${lang === "en" ? "text-primary" : "text-muted-foreground/50 hover:text-muted-foreground"}`}
      >
        EN
      </button>
      <span className="text-muted-foreground/30">|</span>
      <button
        onClick={() => switchTo("bg")}
        className={`transition-colors duration-300 ${lang === "bg" ? "text-primary" : "text-muted-foreground/50 hover:text-muted-foreground"}`}
      >
        BG
      </button>
    </div>
  );
};

export default LanguageToggle;
